import {
  Card,
  Container,
  Eyebrow,
  ProductTile,
  Rich,
  ScrollCue,
  Section,
  SectionTitle,
  StepArrow,
} from "@vcn/ui";
import { useContent } from "../content";

export function OpenAccess() {
  const { openAccess, ui } = useContent()

  return (
    <Section id="open-access" className="scroll-mt-20">
      <Container>
        <div className="text-center">
          <Eyebrow>{openAccess.eyebrow}</Eyebrow>
          <SectionTitle className="mt-4">
            {openAccess.title.map((line) => (
              <span key={line} className="block">
                {line}
              </span>
            ))}
          </SectionTitle>
        </div>

        <ol className="mt-14 grid gap-4 md:grid-cols-[1fr_auto_1fr_auto_1fr] md:items-stretch md:gap-0">
          {openAccess.steps.map((step, index) => (
            <li key={step} className="contents">
              {/* Der Text steht im Entwurf mittig im Rechteck – nicht oben. */}
              <Card className="flex items-center justify-center text-center text-[0.95rem] leading-relaxed text-pretty text-white/90">
                <span>
                  <Rich text={step} strong={["CAP", "CAP GO", "FLOW", "SCALE"]} />
                </span>
              </Card>
              {index < openAccess.steps.length - 1 && (
                <div className="flex items-center justify-center py-2 md:px-4 md:py-0">
                  <StepArrow className="rotate-90 md:rotate-0" />
                </div>
              )}
            </li>
          ))}
        </ol>

        {/* Reseller ── CAP ── Supplier. Bleibt laut Entwurf auch mobil waagerecht. */}
        <div className="mt-20 flex items-center justify-center gap-2 sm:mt-24 sm:gap-4">
          <p className="shrink-0 text-base font-bold text-white sm:text-lg">
            {openAccess.poles.left}
          </p>

          <Connector side="left" />

          <ProductTile
            brand="cap"
            width="clamp(4.5rem, 16vw, 10.5rem)"
            shadow={false}
            decorative
          />

          <Connector side="right" />

          <p className="shrink-0 text-base font-bold text-white sm:text-lg">
            {openAccess.poles.right}
          </p>
        </div>

        <ScrollCue
          href="#zielgruppen"
          label={ui.toAudiences}
          className="mt-16"
        />
      </Container>
    </Section>
  );
}

/** Linie zwischen Rollenname und Kachel – der Punkt sitzt am äußeren Ende
    (Element 614 bzw. 615) und schließt ohne Lücke an die Linie an. */
function Connector({ side }: { side: "left" | "right" }) {
  const dot = (
    <span className="size-1.5 shrink-0 rounded-full bg-[var(--brand-line)]" />
  );
  const line = <span className="h-px w-full bg-[var(--brand-line)]" />;

  return (
    <div
      aria-hidden="true"
      className="flex min-w-4 flex-1 items-center justify-center sm:max-w-32"
    >
      {side === "left" ? dot : line}
      {side === "left" ? line : dot}
    </div>
  );
}
